(() => {
  'use strict';

  const STORAGE_KEY = 'nj_collection_scroll_state_v3';
  const MAX_AUTO_LOADS = 40; // safety
  const PRODUCT_SEL = 'product-card[handle], product-card, .product-item, .product-card';
  const LOAD_MORE_BTN_SEL = [
    'load-more-pagination [data-load-more-button]',
    '[data-load-more-button]'
  ].join(',');

  function isLikelyCollectionPage() {
    // Prestige doesn't add template classes on <body>. Use robust checks:
    const path = location.pathname || '';
    if (!path.includes('/collections/')) return false;
    // Exclude the collections index page
    if (/\/collections\/?$/.test(path)) return false;
    // Require a product grid presence
    return !!document.querySelector(PRODUCT_SEL) || !!document.querySelector('load-more-pagination') || !!document.querySelector('[data-section-type="collection"]');
  }

  function getProductCount() {
    return document.querySelectorAll(PRODUCT_SEL).length;
  }

  function isProductLink(a) {
    const href = (a.getAttribute('href') || '').trim();
    return href.includes('/products/');
  }

  function saveState() {
    if (!isLikelyCollectionPage()) return;

    const state = {
      url: location.href,
      scrollY: window.scrollY,
      productCount: getProductCount(),
      ts: Date.now()
    };

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  async function waitForCountIncrease(prevCount, timeoutMs = 9000) {
    const start = Date.now();
    return new Promise((resolve) => {
      const tick = () => {
        const c = getProductCount();
        if (c > prevCount) return resolve(true);
        if (Date.now() - start > timeoutMs) return resolve(false);
        setTimeout(tick, 60);
      };
      tick();
    });
  }

  async function ensureProductsLoaded(targetCount) {
    let loads = 0;
    while (getProductCount() < targetCount && loads < MAX_AUTO_LOADS) {
      const btn = document.querySelector(LOAD_MORE_BTN_SEL);
      if (!btn) break;

      const prev = getProductCount();

      // If button has next-url, we can also guard for empty
      const nextUrl = btn.getAttribute('data-next-url');
      if (nextUrl === '') break;

      if (btn.disabled || btn.getAttribute('aria-busy') === 'true' || btn.classList.contains('is-loading')) {
        const ok = await waitForCountIncrease(prev, 9000);
        if (!ok) break;
        continue;
      }

      btn.click();
      loads += 1;

      const ok = await waitForCountIncrease(prev, 12000);
      if (!ok) break;
    }
  }

  async function restoreState() {
    if (!isLikelyCollectionPage()) return;

    let raw = null;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (!raw) return;

    let state = null;
    try { state = JSON.parse(raw); } catch (e) { return; }

    if (!state || state.url !== location.href) return;
    if (state.ts && (Date.now() - state.ts) > 1000 * 60 * 30) return;

    const targetCount = Number(state.productCount || 0);
    const targetScroll = Number(state.scrollY || 0);

    if (targetCount > 0) {
      await ensureProductsLoaded(targetCount);
    }

    // Allow layout to settle
    requestAnimationFrame(() => {
      window.scrollTo(0, targetScroll);
    });
  }

  // Save only when navigating to a product page from a collection
  document.addEventListener('click', (e) => {
    if (!isLikelyCollectionPage()) return;
    const a = e.target.closest('a[href]');
    if (!a) return;
    if (!isProductLink(a)) return;
    saveState();
  }, { capture: true });

  // Restore on BFCache and normal loads
  window.addEventListener('pageshow', () => restoreState());
  document.addEventListener('DOMContentLoaded', () => restoreState());
})();